import request from '@/utils/request'

let path = process.env.VUE_APP_AUTH_API || "";

// 通用上传接口
export function uploadOneFile(data,uploadProcess) {
    return request({
      headers: {
        'Content-type': 'multipart/form-data',
      },
      //url: path + '/cloud/minio/uploadOneFile',
      url: path + '/cloud/file/upload',
      method: 'post',
      data: data,
      onUploadProgress: (progressEvent) => {
        // let percent = Math.round(
        //   (progressEvent.loaded / progressEvent.total) * 100 - 1
        // );
        console.log(progressEvent);
        uploadProcess && uploadProcess(progressEvent);
      },
    
    })
 
}


// export function uploadOneFile(params, uploadProcess) {
//   return request("/cloud/minio/uploadOneFile", METHOD.POST, params, {
//     onUploadProgress: (progressEvent) => {
//       let percent = Math.round(
//         (progressEvent.loaded / progressEvent.total) * 100 - 1
//       );
//       console.log(progressEvent);
//       uploadProcess && uploadProcess(percent);
//     },
//   });
// }

//下载文件
export function downloadOneFile(data) {
  return request({
    headers: {
      'Content-type': 'multipart/form-data',
    },
    url: path + '/cloud/minio/downloadOneFile',
    method: 'post',
    data: data
  })

}
